'use client';
import { sendGTMEvent } from '@next/third-parties/google';
import { useCallback } from 'react';

import type { TpGoogleParameters } from '@features/Analytics/types';
import { useShouldInit } from './useShouldInit';

export const useAnalytics = () => {
  const { shouldGoogleAnalyticsInit } = useShouldInit();

  const trackGoogleEvent = useCallback(
    (value: TpGoogleParameters) => {
      const modifiedValue = Object.assign(value, {
        options: {
          email: value?.options?.email ?? 'missEmail',
          ...value.options,
        },
      });
      shouldGoogleAnalyticsInit && sendGTMEvent(modifiedValue);
    },
    [shouldGoogleAnalyticsInit],
  );

  return {
    trackGoogleEvent,
  };
};
